import { DocumentData, Firestore, QuerySnapshot } from 'firebase/firestore';
import { typeUniqueId } from "../../../../dataObjects/types"
import { FirebaseAppSingleton } from "../../../cloudServices/googleFirebaseServices/FirebaseAppSingleton";
import { IFirestoreImageLinkRepository_Ext, FirestoreImageLinkRepository_Ext } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreImageLinkRepository";


export function getImageLinksForIds_onSnapshot(ids: Array<typeUniqueId>, callback: (snapshot: QuerySnapshot<DocumentData>) => void): Promise<Array<() => void>> {
  return new Promise<Array<() => void>>(async (resolve, reject) => {
    try {
      // initialize a Firestore object instance
      const firestoreObj: Firestore = FirebaseAppSingleton.firestore;

      const firestoreImageLinkRepository_Ext: IFirestoreImageLinkRepository_Ext = new FirestoreImageLinkRepository_Ext(firestoreObj);

      // fetch the imageLinks for the pertinent collection of imageLink Ids
      const unsubscribeCallbacks: Array<() => void> = await firestoreImageLinkRepository_Ext.getObjectsForIds_onSnapshot(ids, callback);

      resolve(unsubscribeCallbacks);
    }
    catch (error: any) {
      reject(error);
    }
  });
}